<template>
  <el-dialog
    :append-to-body="true"
    :close-on-click-modal="false"
    :before-close="cancel"
    :visible.sync="dialog"
    title="听力精听"
    width="80%"
  >
    <!--  -->
    <div class="app-container">
      <!--工具栏-->
      <div class="head-container">
        <!-- 搜索 -->
        <el-select
          v-model="type"
          clearable
          placeholder="类型"
          class="filter-item"
          style="width: 200px"
        >
          <el-option
            v-for="item in open"
            :key="item.id"
            :label="item.val"
            :value="item.id"
          />
        </el-select>
        <el-button
          class="filter-item"
          size="mini"
          type="success"
          icon="el-icon-search"
          @click="toQuery"
          >搜索</el-button
        >
      </div>
      <!--表格渲染-->
      <el-table
        v-loading="loading"
        :data="arrData"
        size="small"
        style="width: 100%"
      >
        <el-table-column prop="num" label="序号" width="80" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 + page * size }}
          </template>
        </el-table-column>

        <el-table-column prop="type" label="类型" width="200" align="center">
          <template slot-scope="scope">
            <span v-for="item in open">{{
              scope.row.type == item.id ? item.val : ""
            }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="topTime" label="日期" width="200" align="center">
        </el-table-column>

        <el-table-column prop="cnTitle" label="中文名称" align="center">
        </el-table-column>

        <el-table-column prop="enTitle" label="英文名称" align="center">
        </el-table-column>

        <el-table-column prop="jsonData" label="音频" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.jsonData.audioUrl }}</span>
          </template>
        </el-table-column>

        <el-table-column label="选择" align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-plus"
              @click="doShow(scope.row)"
              ></el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!--分页组件-->
      <el-pagination
        :total="total"
        :current-page="page + 1"
        style="margin-top: 8px"
        layout="total, prev, pager, next, sizes"
        @size-change="sizeChange"
        @current-change="pageChange"
      />
    </div>
    <!--  -->
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="cancel">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getToeflHearingList } from "@/api/essenceListens";
export default {
  data() {
    return {
      dialog: false,
      type: null,
      open: [
        {
          id: 1,
          val: "技术",
        },
        {
          id: 2,
          val: "健康",
        },
        {
          id: 3,
          val: "地球",
        },
        {
          id: 4,
          val: "科学",
        },
        {
          id: 5,
          val: "心理",
        },
        {
          id: 6,
          val: "太空",
        },
      ],
      loading: false,
      page: 0,
      size: 10,
      total: null,
      arrData: [],
    };
  },
  created() {
    this.toQuery();
  },
  methods: {
    // 页面事件
    pageChange(e) {
      this.page = e - 1;
      this.getData();
    },
    // 页数事件
    sizeChange(e) {
      this.size = e;
      this.toQuery();
    },
    // 搜索函数
    getData() {
      let url = `?page=${this.page}&size=${this.size}`;
      if (this.type) {
        let str2 = `&type=${this.type}`;
        url = url + str2;
      }
      getToeflHearingList(url).then((val) => {
        this.arrData = val.content;
        for (let i in this.arrData) {
          this.arrData[i].jsonData = JSON.parse(this.arrData[i].jsonData);
        }
        console.log(this.arrData);
        this.total = val.totalElements;
      });
    },
    toQuery() {
      this.page = 0;
      this.getData();
    },
    //
    cancel() {
      this.dialog=false
    },
    // 选中
    doShow(e){
      console.log(e.id);
      this.$emit("returnId",e)
      this.dialog=false
    }
  },
};
</script>

<style scoped>
</style>
